<template>
<div class="scene__container">
  <div class="scene">
    <div class="scene__slide" >
      <video @canplay="$emit('getVideos', $event)" :class="'scene__slide__video__0' + index" v-for="(video, index) in works" :key="video.id" :src="video.img" loop muted playsinline :data-index="index"></video>
    </div>
  </div>
</div>
</template>

<script>
import Works from '@/assets/js/works.json'
import { isMobile } from 'mobile-device-detect'

export default {
  data () {
    return {
      i: 0,
      works: Works
    }
  },

  mounted () {
    document.querySelector('video').style.opacity = '1'
    if (isMobile === true) {
      let videos = document.querySelectorAll('.scene__slide video')
      for (let i = 0; i < videos.length; i++) {
        videos[i].autoplay = true
        videos[i].load()
      }
    } else {
      document.querySelector('video').play()
    }
  }
}
</script>

<style lang="scss" scoped>
// responsive
$phone:640px;
$tablet: 768px;
$desktop: 1024px;

.scene__container
{
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0px;

  @media screen and (max-width:$phone) and (orientation: portrait) {
    height: 100%;
    display: grid;
    grid-template-rows: 32px 0.9fr calc(100vw - 80px) 1.1fr 32px;
  }
}

.scene
{
  width: calc(100vh / 1.5);
  height: calc(100vh / 1.5);
  overflow: hidden;
  display: flex;
  border-radius: calc(100vh / 15);
  transition: width 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

  @media screen and (max-width:$phone) and (orientation: portrait)
  {
    width: calc(100vw - 80px);
    height: calc(100vw - 80px);
    border-radius: calc((100vw - 80px) / 10);
    grid-row-start: 3;
    grid-row-end: 4;
  }

  .scene__slide
  {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    border-radius: calc(100vh / 15);
    overflow: hidden;
    flex-shrink: 0;
    transition: transform 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99), width 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);
    position: relative;

    @media screen and (max-width:$phone) and (orientation: portrait)
    {
      border-radius: calc((100vw - 80px) / 10);
    }

    video
    {
      height: 100%;
      border-radius: calc(100vh / 15);
      width: auto;
      object-fit: cover;
      opacity: 0;
      position: absolute;
    }
  }

  &.scene__project__transition
  {
    width: 70%;

    @media screen and (max-width:$phone) and (orientation: portrait)
    {
      width: calc(100vw - 80px);
      transition: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Slider.vue